






//直接引入/assets/icons目录下的所有svg图片，
const importAll = (requireContext: __WebpackModuleApi.RequireContext) => requireContext.keys().forEach(requireContext);
try {importAll(require.context('../assets/icons', true, /\.svg$/));} catch (error) {console.log(error);}

export default {
  name: "icon",
  props:['name']
}
